import styled from "styled-components";
import { borders, colors } from "@sonder/ui/source/styled/theme";

export const LoginViewContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 38rem;
  height: fit-content;
  margin: 5rem auto;
  border: ${borders.standard};
  border-radius: 0.3rem;
  background-color: ${colors.white};
`;
